<div class="container-fluid pt-3">
    <div class="jumbotron bg-transparent">
      <!-- <h1 class="display-5">IcM</h1> -->
       <div class="score-box">
          <div class="score-box__text">
            Click <a href="https://portal.stratus.ms/sc-monitoring" target="_blank">here</a> and navigate to dashboard section to access all the dashboards.
          </div>
          <ul>
            <li class="score-box__text_li">
              All the dashboards have been migrated to Stratus to enhance the UI Experience.
            </li>
            <li class="score-box__text_li">
              If you do not have access to stratus dashboard - Request access to this SG to access dashboard page on stratus - <a href="https://idweb.microsoft.com/IdentityManagement/aspx/common/GlobalSearchResult.aspx?searchtype=e0c132db-08d8-4258-8bce-561687a8a51e&content=M360CatalogReaders&popupFromClipboard=%2Fidentitymanagement%2Faspx%2FGroups%2FEditGroup.aspx%3Fid%3D47d05989-1be9-4292-a185-2f3fd9983d68" target="_blank">
                M360CatalogReaders
              </a>, <a href="https://idweb.microsoft.com/IdentityManagement/aspx/common/GlobalSearchResult.aspx?searchtype=e0c132db-08d8-4258-8bce-561687a8a51e&content=M360CatalogWriters&popupFromClipboard=%2Fidentitymanagement%2Faspx%2FGroups%2FEditGroup.aspx%3Fid%3Df9807776-f23a-4353-ac5a-28b7ef1969cd" target="_blank">
                M360CatalogWriters
              </a>.
            </li>
            <li class="score-box__text_li">
              If you have any queries, please reach out to the support team at 
              <a href="mailto:M360PlatAdmin@microsoft.com">M360PlatAdmin&#64;microsoft.com</a>
            </li>
          </ul>
        </div>
      <hr class="my-4">
      <p class="lead">The SupplyChain Dashboard Catalog is your one stop location to get information on solutions and dasboards built across the organization in a standard template. Add entry for your dashboard, assign owners to ensure Role Based Access. The solutions are classified based on the Levels and searchable in the Browsing catalog. Add, Manage, Browse, Search!</p>
    </div>
  </div>